import PropTypes from "prop-types";
import { lazy, Suspense, useContext } from "react";
import { Outlet, Navigate, useRoutes } from "react-router-dom";

import DashboardLayout from "../layouts/dashboard";
import { AuthContext } from "../providers/AuthProvider";

export const IndexPage = lazy(() => import("../pages/app"));
export const BlogPage = lazy(() => import("../pages/blog"));
export const CursosPage = lazy(() => import("../pages/cursos"));
export const TalentsPage = lazy(() => import("../pages/talents"));
export const PartnersPage = lazy(() => import("../pages/partners"));
export const CompaniesPage = lazy(() => import("../pages/companies"));
export const PlansPage = lazy(() => import("../pages/Planos"));
export const QuestonsPage = lazy(() => import("../pages/questioneEditing"));
export const FinancePage = lazy(() => import("../pages/finance"));
export const SidekiqPage = lazy(() => import("../pages/sidekiq"));
export const LoginPage = lazy(() => import("../pages/login"));
export const ProductsPage = lazy(() => import("../pages/products"));
export const Page404 = lazy(() => import("../pages/page-not-found"));

// ----------------------------------------------------------------------
export default function Router() {
  if (
    window.location.protocol === "http:" &&
    window.location.hostname !== "localhost"
  ) {
    window.location.href = window.location.href.replace("http:", "https:");
  }

  const routes = useRoutes([
    {
      element: (
        <PrivateRoute>
          <DashboardLayout>
            <Suspense>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </PrivateRoute>
      ),
      children: [
        { element: <IndexPage />, index: true },
        { path: "talents", element: <TalentsPage /> },
        { path: "companies", element: <CompaniesPage /> },
        { path: "partners", element: <PartnersPage /> },
        { path: "questions", element: <QuestonsPage /> },
        { path: "finance", element: <FinancePage /> },
        { path: "sidekiq", element: <SidekiqPage /> },
        { path: "conteudos", element: <CursosPage /> },
        { path: "planos", element: <PlansPage /> },
      ],
    },
    {
      path: "/login",
      element: (
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      ),
    },
    {
      path: "404",
      element: <Page404 />,
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}

function PrivateRoute({ children }) {
  const { user, loading } = useContext(AuthContext);

  if (!user & !loading) {
    return <Navigate to="/login" />;
  }

  return children;
}

function PublicRoute({ children }) {
  const { user } = useContext(AuthContext);

  if (user) {
    return <Navigate to="/" />;
  }

  return children;
}

PublicRoute.propTypes = {
  children: PropTypes.node,
};

PrivateRoute.propTypes = {
  children: PropTypes.node,
};
